import { AppError } from '@app/domain/entities';

/**
 * Thrown when a Google Drive API call returns an unexpected HTTP status.
 * Endpoint and status travel with the error so AppErrorHandler can log them
 * in one place without intermediate console.error in the adapter.
 */
export class DriveApiError extends AppError {
  readonly code = 'E_DRIVE_API';

  constructor(
    public readonly endpoint: string,
    public readonly status: number,
    message?: string,
    cause?: unknown,
  ) {
    super(message ?? `Google Drive API error ${status}`, { endpoint, status }, { cause });
  }
}
